module.exports = __webpack_public_path__ + "img/rating-g2.6464e7a4.webp";